import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
export default function DCardHeader({ className, style, children, }) {
    return (_jsx("div", { className: classNames('card-header', className), style: style, children: children }));
}
//# sourceMappingURL=DCardHeader.js.map